const dotpathlookup = require('@ua/dotpathlookup')

const pageContext = require('airship/modules/page-context').default

const lookup = dotpathlookup('context_processors.ui_url')

module.exports = getUiUrl

function getUiUrl() {
  return lookup(pageContext()) || '/media/'
}
